export const state = () => ({
  user: {},
  campsite: {},
  links: [],
  socialAccounts: [],
  page: 1,
  hasMoreLinks: true,
});

export const getters = {
  isFreePlan: (state) => state.user.plan === 'free',
  hasCampsite: (state) => Object.keys(state.campsite).length > 0,
};

export const mutations = {
  set(state, { key, value }) {
    state[key] = value;
  },
};

export const actions = {
  async get({ commit }, { username }) {
    const { data } = await this.$axios.get(
      `${this.app.$config.profileApiBaseUrl}/camper/get-camper-profile`,
      {
        params: {
          username,
        },
      },
    );

    // console.log(data.links);

    commit('set', { key: 'user', value: data.user });
    commit('set', { key: 'campsite', value: data.campsite });
    commit('set', { key: 'socialAccounts', value: data.social_accounts || [] });
    commit('set', {
      key: 'links',
      value: data.links || [],
    });
    commit('set', { key: 'hasMoreLinks', value: data.has_more || false });

    return data;
  },

  async links({ commit, state }, { username, page }) {
    const { data } = await this.$axios.get(
      `${this.app.$config.apiBaseUrl}/public/links?username=${username}&page=${page}`,
    );

    commit('set', { key: 'links', value: [...state.links, ...data.links] });
    commit('set', { key: 'hasMoreLinks', value: data.has_more || false });

    return data;
  },
};
